export default {
  // Login page
  login: {
    title: "Welcome Back",
    subtitle: "Sign in to your account to continue",
    developmentMode: "Development Mode: API endpoint is",
    phoneOrEmail: "Phone Number or Email",
    password: "Password",
    fieldRequired: "This field is required",
    rememberMe: "Remember me",
    forgotPassword: "Forgot Password?",
    signIn: "Sign In",
    noAccount: "Don't have an account?",
    createAccount: "Create Account"
  },

  // Signup page
  signup: {
    title: "Create Account",
    subtitle: "Join us and start managing your shipments",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    createAccount: "Create Account",
    haveAccount: "Already have an account?",
    signIn: "Sign In"
  },

  // Forgot password page
  forgotPassword: {
    title: "Forgot Password",
    subtitle: "Enter your email address and we'll send you a reset code",
    emailAddress: "Email Address",
    sendResetCode: "Send Reset Code",
    rememberPassword: "Remember your password?",
    backToLogin: "Back to Login?",
    signIn: "Sign In",
    noAccount: "Don't have an account?",
    createAccount: "Create Account",
    
    // Success state
    successTitle: "Check Your Email",
    successSubtitle: "We've sent a password reset code to your register phone number or email",
    resetCodeSent: "Reset Code Sent!",
    checkEmailMessage: "Please check your email for the password reset code and follow the instructions to reset your password.",
    tryDifferentEmail: "Try Different Email"
  },

  // Confirm forgotten password page
  confirmForgottenPassword: {
    title: "Reset Password",
    subtitle: "Enter your new password to complete the reset process",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    resetPassword: "Reset Password",
    successMessage: "Password reset successfully! Please login with your new password."
  },

  // Confirm OTP page
  confirmOtp: {
    title: "Verify Your Account",
    subtitle: "We've sent a verification code to",
    enterCode: "Enter verification code",
    codeInstructions: "Enter the 6-digit verification code sent to your email address.",
    verifyAccount: "Verify Account",
    resendCode: "Resend Code",
    backToLogin: "Back to Login"
  },

  // Common validation messages
  validation: {
    fillAllFields: "Please fill in all fields",
    passwordsNotMatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 6 characters long",
    invalidEmail: "Please enter a valid email address",
    enterEmail: "Please enter your email address",
    enterVerificationCode: "Please enter the verification code",
    invalidVerificationCode: "Please enter a valid verification code"
  },

  // Common error messages
  errors: {
    resetCodeFailed: "Failed to send reset code. Please try again.",
    unexpectedError: "An unexpected error occurred. Please try again later.",
    verificationFailed: "Verification failed. Please check your code and try again.",
    resetPasswordFailed: "Failed to reset password. Please try again.",
    invalidCredentials: "Invalid email/phone or password. Please check your credentials and try again.",
    accountBanned: "Your account has been suspended. Please contact support for assistance.",
    confirmOTP: "Please verify your account first. Check your email for the verification code.",
    loginFailed: "Login failed. Please try again.",
    networkError: "Network error. Please check your connection and try again."
  }
};
